import { render, staticRenderFns } from "./grade.vue?vue&type=template&id=7bdda2f3"
import script from "./grade.vue?vue&type=script&lang=ts"
export * from "./grade.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports